import { useNavigate } from 'react-router-dom';

export default function MiniPerfil({ user }) {
    const navigate = useNavigate();

    // Lógica de nome aprimorada: se for muito longo, corta, senão mantém o primeiro nome
    const displayName = user.name.split(' ')[0].length > 8
        ? user.name.split(' ')[0].substring(0, 7) + '...'
        : user.name.split(' ')[0];

    return (
        <div className="group relative">
            <button
                onClick={() => navigate('/usuario', { state: user })}
                className="flex flex-col items-center gap-2 p-3 rounded-2xl transition-all duration-300
                           bg-white dark:bg-[#0a2652] 
                           border border-gray-100 dark:border-white/5
                           hover:border-blue4/50 hover:shadow-lg hover:shadow-blue-500/10 
                           hover:-translate-y-1 active:scale-95"
                title={user.name}
            >
                {/* Avatar com Ring de Destaque no Hover */}
                <div className="relative">
                    <div className="w-12 h-12 rounded-full overflow-hidden flex items-center justify-center bg-gray-50 dark:bg-[#0d2d5f] border-2 border-transparent group-hover:border-blue4 transition-all shadow-sm">
                        <img
                            src={user.img || require("../../assets/logos/logo-icon.png")}
                            alt={user.name}
                            className="w-full h-full object-cover block dark:bg-white"
                            style={{ imageRendering: 'auto' }} // Garante a melhor suavização do navegador
                        />
                    </div>
                </div>

                {/* Nome do Usuário */}
                <span className="text-[10px] font-bold uppercase tracking-wider text-slate-600 dark:text-blue-200/70 group-hover:text-blue4 dark:group-hover:text-blue4 transition-colors">
                    {displayName}
                </span>
            </button>

        </div>
    );
}